import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import AddToBasketButtonWithAjaxCall from '../../AddToBasket/AddToBasketButtonWithAjaxCall';

import { dispatchAddToBasket } from '../productPageBundlesAnalytics';
import UILocale from '../../../../utils/UILocale';


const DynamicBundleSummary = ({
  dynamicBundleImageUrl, dynamicBundleHeaderLabel, mainProductId, dynamicBundleMax,
  dynamicBundlePrice, dynamicBundleSavings, dynamicBundleSeparateSellingPrice,
  productsAddedToDynamicBundle, removeProductFromBundle, restartDynamicBundleCreation,
  showRestartButton, showAddToBasketButton, bundleID, bundleProductIds
}) => (
  <article className={'product packBuilderSummary'}>
    <div className={'bundle'}>
      <ul className={'bundleDesc'}>
        <li>
          <img
            id={'mainProduct'}
            src={dynamicBundleImageUrl}
            alt={dynamicBundleHeaderLabel}
            data-mainfupid={mainProductId}
          />
        </li>
        {
            Array.from({ length: dynamicBundleMax }, (v, i) => i)
              .map((bundleItemNumber) => (
                productsAddedToDynamicBundle.length > bundleItemNumber
                  ? (
                    <li
                      key={`${productsAddedToDynamicBundle[bundleItemNumber].productID
                      }-${bundleItemNumber}`}
                    >
                      <span className={'item'}>
                        <div className={'btn-remove'}>
                          <img
                            src={productsAddedToDynamicBundle[bundleItemNumber].productImage}
                            alt={productsAddedToDynamicBundle[bundleItemNumber].productName}
                          />
                          <button
                            name={'remove'}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              removeProductFromBundle(
                                productsAddedToDynamicBundle[bundleItemNumber].productID
                              );
                            }}
                          >
                            x
                          </button>
                        </div>
                      </span>
                    </li>
                  )
                  : (
                    <li key={`${bundleItemNumber}-empty`}>
                      <span id={`bundleItemPlaceholder${bundleItemNumber}`} className={'item'}>
                        <span>
                          {UILocale.getString('dynamic.bundles.bundle_item')}
                          <br />
                          <strong>
                            {bundleItemNumber + 2}
                          </strong>
                        </span>
                      </span>
                    </li>
                  )

              ))
          }
      </ul>
      <p
        className={'productTitle noMobile'}
        dangerouslySetInnerHTML={{
          __html: dynamicBundleHeaderLabel
        }}
      />
    </div>
    <div id={'bundlePriceBox'} className={'productPrices'}>
      <div className={'currentBundlePrice'}>{dynamicBundlePrice}</div>
      {(dynamicBundleSeparateSellingPrice || dynamicBundleSavings) && (
        <>
          {dynamicBundleSeparateSellingPrice ? (
            <div>
              <small>
                {UILocale.getString('component.productPage.separate_selling_price')}
                {' '}
                {dynamicBundleSeparateSellingPrice}
              </small>
            </div>
          ) : null}
          {dynamicBundleSavings ? (
            <div>
              <small>
                {UILocale.getString('dynamic.bundles.save')}
                {' '}
                {dynamicBundleSavings}
              </small>
            </div>
          ) : null}
        </>
      )}
    </div>
    {showAddToBasketButton && (
      <div className={'productPurchase'}>
        <AddToBasketButtonWithAjaxCall
          fupid={bundleID}
          quantity={1}
          buttonLabel={UILocale.getString('dynamic.bundles.add_pack')}
          beforeAddingToBasket={() => {
            dispatchAddToBasket(bundleProductIds, 'userCreated');
          }}
        />
      </div>
    )}
    {showRestartButton && (
      <div className={'packRestart'}>
        <button
          type={'submit'}
          className={'btn'}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            restartDynamicBundleCreation();
          }}
        >
          {UILocale.getString('dynamic.bundles.restart')}
        </button>
      </div>
    )}
  </article>
);

DynamicBundleSummary.propTypes = {
  mainProductId: PropTypes.string.isRequired,
  dynamicBundleHeaderLabel: PropTypes.string.isRequired,
  dynamicBundlePrice: PropTypes.string.isRequired,
  dynamicBundleSavings: PropTypes.string,
  dynamicBundleSeparateSellingPrice: PropTypes.string,
  dynamicBundleImageUrl: PropTypes.string.isRequired,
  dynamicBundleMax: PropTypes.number.isRequired,
  productsAddedToDynamicBundle: PropTypes.arrayOf(
    PropTypes.shape({
      productID: PropTypes.string.isRequired,
      productName: PropTypes.string.isRequired,
      productImage: PropTypes.string.isRequired
    })
  ).isRequired,
  removeProductFromBundle: PropTypes.func.isRequired,
  restartDynamicBundleCreation: PropTypes.func.isRequired,
  showRestartButton: PropTypes.bool.isRequired,
  showAddToBasketButton: PropTypes.bool.isRequired,
  bundleID: PropTypes.string,
  bundleProductIds: PropTypes.arrayOf(PropTypes.string)
};

DynamicBundleSummary.defaultProps = {
  dynamicBundleSavings: '',
  dynamicBundleSeparateSellingPrice: '',
  bundleID: '',
  bundleProductIds: []
};

export default DynamicBundleSummary;
